module search {
  'use strict';

  export class SearchCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      'searchService',
      '$element',
      '$window',
      '$timeout',
      'anchorNavService',
      'pageMetaService',
      '$mdDialog',
    ];
    
    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope: ISearchScope,
      private searchService: ISearchService,
      private $element: JQuery,
      private $window: ng.IWindowService,
      private $timeout: ng.ITimeoutService,
      private anchorNavService : navigation.IAnchorNavService,
      private pageMetaService: navigation.IPageMetaService,
      private $mdDialog: ng.material.IDialogService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      var init = () => {
        this.elInput = searchService.getKeywordInputElement();
        if (!this.elInput) {
           $timeout(init, 300);
        }
        if (anchorNavService.getPath().lastIndexOf('/') == (anchorNavService.getPath().length - 1)
          && angular.equals({}, anchorNavService.search())) {
        
          $timeout(() => {this.elInput.focus()}, 300);
        }        
        this.position(null);
      }
      
      angular.element($window).bind("resize", this.position);
      angular.element($window).bind('load', () => {
        init();
      });

      searchService.subscribe($scope, () => {
        $scope.data = searchService.getData();   
        this.position(null);     
      });

      $scope.hasResults = true;
      searchService.subscribeLoading($scope, (event: ng.IAngularEvent, isLoading: boolean) => {
        var data = searchService.getData();
        if (!isLoading && data && data.query > "") {  
          
          if (!data.topResult) {
            $scope.limit = 10;
          }
          
          $scope.hasResults = (data.tasks && data.tasks.Hits.length > 0
            || data.industries && data.industries.Hits.length > 0
            || data.products && data.products.Hits.length > 0
            || data.documents && data.documents.Hits.length > 0
            || data.parts && data.parts.Hits.length > 0
            || data.productArchive && data.productArchive.Hits.length > 0);
        } else {
          $scope.limit = 5;
          $scope.hasResults = true;
        }
      });

    }

    elInput : JQuery;

    getIconIRI(prefix: string, icon: string) {
      return prefix + icon;
    }

    search() : void {

    }

    position(ev:JQueryEventObject) : void {
      if (!this.elInput) return;
      var elRelative : JQuery = this.elInput.offsetParent();
      while (elRelative.css("position") !== "relative") {
        elRelative = elRelative.offsetParent();
      }

      $(this.$element).css({
        top: this.elInput.offset().top - elRelative.offset().top + this.elInput.outerHeight()
        , left: this.elInput.offset().left
        , width : this.elInput.outerWidth()
      });
    };

    

    openPart(ev: MouseEvent, partid: string) : void {
      ev.preventDefault();

      this.anchorNavService.search("partid", partid);

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'PartDetailCtrl',
        templateUrl: 'part/PartDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          partId: partid,
          parentScope: this.$scope
        },
      })
        .then(() => {
          this.anchorNavService.search({"partid": null});
          //console.log('Modal closed at: ' + new Date());
        }, () => {
          this.anchorNavService.search({"partid": null});
          //console.log('Modal canceled at: ' + new Date());
        });
    }



    

    openDocument(ev: MouseEvent, fileSrcRevId: number) : void  {
      ev.preventDefault();

      this.anchorNavService.search("revid", fileSrcRevId);

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'LibraryDetailCtrl',
        templateUrl: 'library/LibraryDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        //fullscreen: true, // Only for -xs, -sm breakpoints.
        locals: {
          revId: fileSrcRevId,
          parentScope: this.$scope
        },
      })
        .then( () => {
          this.anchorNavService.search({"revid": null});
          //console.log('Modal closed at: ' + new Date());
        }, () => {
          this.anchorNavService.search({"revid": null});
          //console.log('Modal canceled at: ' + new Date());
        });
    }

    
  }

}